import { clsx } from 'clsx'

interface StatusBadgeProps {
  status: string
  className?: string
}

export default function StatusBadge({ status, className }: StatusBadgeProps) {
  const statusStyles: Record<string, string> = {
    running: 'bg-green-100 text-green-700 border-green-200',
    stopped: 'bg-gray-100 text-gray-700 border-gray-200',
    failed: 'bg-red-100 text-red-700 border-red-200',
    starting: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    stopping: 'bg-orange-100 text-orange-700 border-orange-200',
    created: 'bg-blue-100 text-blue-700 border-blue-200',
    unknown: 'bg-gray-100 text-gray-500 border-gray-200',
  }

  const statusDots: Record<string, string> = {
    running: 'bg-green-500',
    stopped: 'bg-gray-400',
    failed: 'bg-red-500',
    starting: 'bg-yellow-500 animate-pulse',
    stopping: 'bg-orange-500 animate-pulse',
    created: 'bg-blue-500',
    unknown: 'bg-gray-400',
  }

  const normalizedStatus = status.toLowerCase()

  return (
    <span
      className={clsx(
        'inline-flex items-center space-x-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium',
        statusStyles[normalizedStatus] || statusStyles.unknown,
        className
      )}
    >
      <span className={clsx(
        'h-1.5 w-1.5 rounded-full',
        statusDots[normalizedStatus] || statusDots.unknown
      )} />
      <span className="capitalize">{status}</span>
    </span>
  )
}
